import { default as _91_46_46_46cms_93urkN5EC8iyMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93UN4xdf2FgbMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexAI6l0uMwUOMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93AhaPlpYld0Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/akcii/[...slug].vue?macro=true";
import { default as indexKMV2CMnqGoMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93Gav6VjYRS2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/articles/[...slug].vue?macro=true";
import { default as indexl4LVqLIZZwMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/articles/index.vue?macro=true";
import { default as indexzUt06g9RA3Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/authorization/index.vue?macro=true";
import { default as indexqh3ySCaxQtMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93JMAYAsARM5Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93vpQ0H9Fc8KMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/catalog/[...slug].vue?macro=true";
import { default as indexyW7eV718QKMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93xxHio5d2EjMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultO8vKxic5JcMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/catalogsearch/result.vue?macro=true";
import { default as index8syhFGxBkfMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93nvblOqAP1JMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93HMglRyYnWgMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/fabriki/[...slug].vue?macro=true";
import { default as indexnepM3IvD2tMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/fabriki/index.vue?macro=true";
import { default as _91_46_46_46slug_93QvHXycGMfGMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/product/[...slug].vue?macro=true";
import { default as indexoXiFEWcxCCMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/profile/index.vue?macro=true";
import { default as indexgbp5jXLuusMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/profile/orders/index.vue?macro=true";
import { default as indexMd1norPW8iMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93AC5fqRAJFoMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/sets/[...slug].vue?macro=true";
import { default as index23TwL8qJwaMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93urkN5EC8iyMeta?.name ?? "cms",
    path: _91_46_46_46cms_93urkN5EC8iyMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93urkN5EC8iyMeta || {},
    alias: _91_46_46_46cms_93urkN5EC8iyMeta?.alias || [],
    redirect: _91_46_46_46cms_93urkN5EC8iyMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93UN4xdf2FgbMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93UN4xdf2FgbMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93UN4xdf2FgbMeta || {},
    alias: _91_46_46_46slug_93UN4xdf2FgbMeta?.alias || [],
    redirect: _91_46_46_46slug_93UN4xdf2FgbMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexAI6l0uMwUOMeta?.name ?? "3d-projects",
    path: indexAI6l0uMwUOMeta?.path ?? "/3d-projects",
    meta: indexAI6l0uMwUOMeta || {},
    alias: indexAI6l0uMwUOMeta?.alias || [],
    redirect: indexAI6l0uMwUOMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93AhaPlpYld0Meta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93AhaPlpYld0Meta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93AhaPlpYld0Meta || {},
    alias: _91_46_46_46slug_93AhaPlpYld0Meta?.alias || [],
    redirect: _91_46_46_46slug_93AhaPlpYld0Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexKMV2CMnqGoMeta?.name ?? "akcii",
    path: indexKMV2CMnqGoMeta?.path ?? "/akcii",
    meta: indexKMV2CMnqGoMeta || {},
    alias: indexKMV2CMnqGoMeta?.alias || [],
    redirect: indexKMV2CMnqGoMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Gav6VjYRS2Meta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93Gav6VjYRS2Meta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93Gav6VjYRS2Meta || {},
    alias: _91_46_46_46slug_93Gav6VjYRS2Meta?.alias || [],
    redirect: _91_46_46_46slug_93Gav6VjYRS2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexl4LVqLIZZwMeta?.name ?? "articles",
    path: indexl4LVqLIZZwMeta?.path ?? "/articles",
    meta: indexl4LVqLIZZwMeta || {},
    alias: indexl4LVqLIZZwMeta?.alias || [],
    redirect: indexl4LVqLIZZwMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexzUt06g9RA3Meta?.name ?? "authorization",
    path: indexzUt06g9RA3Meta?.path ?? "/authorization",
    meta: indexzUt06g9RA3Meta || {},
    alias: indexzUt06g9RA3Meta?.alias || [],
    redirect: indexzUt06g9RA3Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexqh3ySCaxQtMeta?.name ?? "cart",
    path: indexqh3ySCaxQtMeta?.path ?? "/cart",
    meta: indexqh3ySCaxQtMeta || {},
    alias: indexqh3ySCaxQtMeta?.alias || [],
    redirect: indexqh3ySCaxQtMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93JMAYAsARM5Meta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93JMAYAsARM5Meta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93JMAYAsARM5Meta || {},
    alias: _91_46_46_46id_93JMAYAsARM5Meta?.alias || [],
    redirect: _91_46_46_46id_93JMAYAsARM5Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93vpQ0H9Fc8KMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93vpQ0H9Fc8KMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93vpQ0H9Fc8KMeta || {},
    alias: _91_46_46_46slug_93vpQ0H9Fc8KMeta?.alias || [],
    redirect: _91_46_46_46slug_93vpQ0H9Fc8KMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexyW7eV718QKMeta?.name ?? "catalog",
    path: indexyW7eV718QKMeta?.path ?? "/catalog",
    meta: indexyW7eV718QKMeta || {},
    alias: indexyW7eV718QKMeta?.alias || [],
    redirect: indexyW7eV718QKMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93xxHio5d2EjMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93xxHio5d2EjMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93xxHio5d2EjMeta || {},
    alias: _91_46_46_46slug_93xxHio5d2EjMeta?.alias || [],
    redirect: _91_46_46_46slug_93xxHio5d2EjMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultO8vKxic5JcMeta?.name ?? "catalogsearch-result",
    path: resultO8vKxic5JcMeta?.path ?? "/catalogsearch/result",
    meta: resultO8vKxic5JcMeta || {},
    alias: resultO8vKxic5JcMeta?.alias || [],
    redirect: resultO8vKxic5JcMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: index8syhFGxBkfMeta?.name ?? "clear-page-slider",
    path: index8syhFGxBkfMeta?.path ?? "/clear-page-slider",
    meta: index8syhFGxBkfMeta || {},
    alias: index8syhFGxBkfMeta?.alias || [],
    redirect: index8syhFGxBkfMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93nvblOqAP1JMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93nvblOqAP1JMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93nvblOqAP1JMeta || {},
    alias: _91_46_46_46slug_93nvblOqAP1JMeta?.alias || [],
    redirect: _91_46_46_46slug_93nvblOqAP1JMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93HMglRyYnWgMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93HMglRyYnWgMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93HMglRyYnWgMeta || {},
    alias: _91_46_46_46slug_93HMglRyYnWgMeta?.alias || [],
    redirect: _91_46_46_46slug_93HMglRyYnWgMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexnepM3IvD2tMeta?.name ?? "fabriki",
    path: indexnepM3IvD2tMeta?.path ?? "/fabriki",
    meta: indexnepM3IvD2tMeta || {},
    alias: indexnepM3IvD2tMeta?.alias || [],
    redirect: indexnepM3IvD2tMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93QvHXycGMfGMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93QvHXycGMfGMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93QvHXycGMfGMeta || {},
    alias: _91_46_46_46slug_93QvHXycGMfGMeta?.alias || [],
    redirect: _91_46_46_46slug_93QvHXycGMfGMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexoXiFEWcxCCMeta?.name ?? "profile",
    path: indexoXiFEWcxCCMeta?.path ?? "/profile",
    meta: indexoXiFEWcxCCMeta || {},
    alias: indexoXiFEWcxCCMeta?.alias || [],
    redirect: indexoXiFEWcxCCMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexgbp5jXLuusMeta?.name ?? "profile-orders",
    path: indexgbp5jXLuusMeta?.path ?? "/profile/orders",
    meta: indexgbp5jXLuusMeta || {},
    alias: indexgbp5jXLuusMeta?.alias || [],
    redirect: indexgbp5jXLuusMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexMd1norPW8iMeta?.name ?? "recently",
    path: indexMd1norPW8iMeta?.path ?? "/recently",
    meta: indexMd1norPW8iMeta || {},
    alias: indexMd1norPW8iMeta?.alias || [],
    redirect: indexMd1norPW8iMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93AC5fqRAJFoMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93AC5fqRAJFoMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93AC5fqRAJFoMeta || {},
    alias: _91_46_46_46slug_93AC5fqRAJFoMeta?.alias || [],
    redirect: _91_46_46_46slug_93AC5fqRAJFoMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index23TwL8qJwaMeta?.name ?? "wishlist",
    path: index23TwL8qJwaMeta?.path ?? "/wishlist",
    meta: index23TwL8qJwaMeta || {},
    alias: index23TwL8qJwaMeta?.alias || [],
    redirect: index23TwL8qJwaMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260519104611/pages/wishlist/index.vue").then(m => m.default || m)
  }
]